import { pageUrl } from 'utilities/pageUrl';

const REDIRECT_BACK_TO_MEMBERSHIP_KEY = 'redirectBackToMembership';
const REDIRECT_BACK_TO_BOOKING_KEY = 'redirectBackToBooking';
const REDIRECT_BACK_TO_BOOKING_URL_KEY = 'redirectBackToBookingUrl';

export const getReturnBackRoute = () => {
  const redirectBackToMembership = localStorage.getItem(REDIRECT_BACK_TO_MEMBERSHIP_KEY);

  if (redirectBackToMembership) {
    return {
      pathname: pageUrl.enterpriseMembershipAccessCode(),
      text: 'Continue to Activate Benefit'
    };
  }

  const redirectBackToBooking = localStorage.getItem(REDIRECT_BACK_TO_BOOKING_KEY);
  if (redirectBackToBooking) {
    return {
      pathname: localStorage.getItem(REDIRECT_BACK_TO_BOOKING_URL_KEY) ?? '',
      text: 'Continue booking'
    };
  } else {
    return { pathname: '/', text: 'Back to dashboard' };
  }
};

export const setReturnBackToBookingRoute = (pathname: string, search: string) => {
  localStorage.setItem(REDIRECT_BACK_TO_BOOKING_KEY, 'true');
  localStorage.setItem(REDIRECT_BACK_TO_BOOKING_URL_KEY, `${pathname}${search}`);
};

export const clearReturnBackRoute = () => {
  localStorage.removeItem(REDIRECT_BACK_TO_MEMBERSHIP_KEY);
  localStorage.removeItem(REDIRECT_BACK_TO_BOOKING_KEY);
  localStorage.removeItem(REDIRECT_BACK_TO_BOOKING_URL_KEY);
};
